import { render, staticRenderFns } from "./CustomerAdd.vue?vue&type=template&id=40f3db1a&scoped=true"
import script from "./CustomerAdd.vue?vue&type=script&lang=js"
export * from "./CustomerAdd.vue?vue&type=script&lang=js"
import style0 from "./CustomerAdd.vue?vue&type=style&index=0&id=40f3db1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3db1a",
  null
  
)

export default component.exports